export default __webpack_public_path__ + "static/media/GTorpedo.31c7273e.png";